import React, { useEffect, useRef, useState } from "react";
import { useLocation } from 'react-router-dom';
import Footer from './Footer.jsx';

const RevealOnScroll = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);
  
    useEffect(() => {
      let observerRefValue = null;
      const scrollObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
              setIsVisible(true);
              scrollObserver.unobserve(entry.target);
          }
        }
      );
      
      scrollObserver.observe(ref.current);
      observerRefValue = ref.current;
  
      return () => {
        if (observerRefValue) {
          scrollObserver.unobserve(observerRefValue);
        }
      };
    }, []);
    
    const classes = `transition-opacity duration-1500 ${isVisible ? 'opacity-100' : 'opacity-0'}`;
  
    return (
      <div ref={ref} className={classes}>
        {children}
      </div>
    );
};

const Home = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
          const targetElement = document.getElementById(location.hash.substring(1));
          if (targetElement) {
              targetElement.scrollIntoView({ behavior: "smooth", block: "end"});
          }
        }
    }, [location]);

    return (
        <div className="min-h-screen text-cyan-800 relative">

            {/* Header */}
            <header className="relative h-screen bg-cover bg-center bg-fixed flex items-stretch justify-center transition-all duration-500 ease-in-out">   
                <RevealOnScroll>
                    <div className="flex flex-col items-center justify-center text-center h-screen relative px-2">
                        <div className="md:text-8xl text-5xl font-semibold">
                            <h1>im still working on this</h1>
                        </div>
                        <a href="/404" type="button" className="transition-all duration-300 ease-in-out text-cyan-800 mt-10 p-5 backdrop-blur-xl 
                            shadow-[0.3rem_0.3rem_1.125rem_0_rgb(197,197,197),-0.3rem_-0.3rem_1.125rem_0_rgb(255,255,255)] rounded-full 
                            hover:shadow-[0.5rem_0.5rem_1.125rem_0_rgb(225,226,228),-0.3rem_-0.3rem_1.125rem_0_rgb(255,255,255)]
                            hover:inset-shadow-lg">
                            <p className="text-s font-semibold">Play Anagrams</p>
                        </a>
                    </div>
                </RevealOnScroll>
                <a id="about" href="#about" className="flex flex-col items-center justify-center absolute bottom-10">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-8 h-8 transform -translate-x-1/2 animate-bounce cursor-pointer z-10">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
                    </svg>
                </a>
            </header>

            {/* Main Content */}
            <main className="flex flex-col items-center justify-center mx-auto p-10 transition-all duration-500 ease-in-out">
                <RevealOnScroll>
                    <div className="transition-all duration-500 ease-in-out p-5 shadow-[0.5rem_0.5rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)] rounded-lg">
                        
                        <p><b className="text-red-500">*</b> Projects here.</p>

                    </div>
                </RevealOnScroll>

                {/* MISSION */}
                <div className="flex flex-col my-4 md:p-8 md:w-3/4">
                    <RevealOnScroll>
                        <h3 className="md:text-xl text-center font-medium mt-10 mb-4">(more fun stuff)</h3>
                    </RevealOnScroll>
                    <div className="md:px-10">
                        <RevealOnScroll>
                            <h1 className="text-center font-bold md:text-6xl text-3xl py-2">About Me</h1>
                        </RevealOnScroll>
                        <RevealOnScroll>
                            <p className="text-left md:text-center md:text-2xl text-xl mt-4 px-10">
                                Interests here
                            </p>
                        </RevealOnScroll>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Home;
